import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./HomeCalendar.css";
import { useGetHolidaysListQuery } from "../../../../../redux/services/internal/apiHome";
import { useSelector } from "react-redux";

const HomeCalendar = ({ benchId }) => {
  const { language } = useSelector((state) => state.sliceLanguage);

  const [date, setDate] = useState(new Date());
  const [holidays, setHolidays] = useState([]);

  const { data: apiData } = useGetHolidaysListQuery(benchId);

  // When the API data changes, map the response to the format needed
  useEffect(() => {
    if (apiData && apiData.status) {
      const holidayList = apiData.data.map((holiday) => ({
        date: new Date(holiday.holiday_date), // Convert holiday_date to Date object
        name: holiday.title,
        type: holiday.holiday_type,
      }));
      setHolidays(holidayList); // Update holidays with API data
    }
  }, [apiData]);

  // Check if the tile date matches a holiday and return holiday object
  const getHoliday = (date) => {
    return holidays.find(
      (holiday) =>
        date.getFullYear() === holiday.date.getFullYear() &&
        date.getMonth() === holiday.date.getMonth() &&
        date.getDate() === holiday.date.getDate()
    );
  };

  // Custom weekday labels
  const customWeekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const customWeekDaysHindi = [
    "रवि",
    "सोम",
    "मंगल",
    "बुध",
    "गुरु",
    "शुक्र",
    "शनि",
  ];

  // Custom month names
  const customMonths = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const customMonthsHindi = [
    "जनवरी",
    "फरवरी",
    "मार्च",
    "अप्रैल",
    "मई",
    "जून",
    "जुलाई",
    "अगस्त",
    "सितंबर",
    "अक्टूबर",
    "नवंबर",
    "दिसंबर",
  ];

  return (
    <>
      <div className="calendar-area mt-4">
        <Calendar
          onChange={setDate}
          value={date}
          formatShortWeekday={(locale, date) =>
            language === "hi"
              ? customWeekDaysHindi[date.getDay()]
              : customWeekDays[date.getDay()]
          }
          formatMonthYear={(locale, date) =>
            language === "hi"
              ? `${customMonthsHindi[date.getMonth()]} ${date.getFullYear()}`
              : `${customMonths[date.getMonth()]} ${date.getFullYear()}`
          }
          tileClassName={({ date, view }) => {
            if (view === "month") {
              const holiday = getHoliday(date);
              if (holiday) {
                return holiday.type === "G"
                  ? "gazetted-holiday"
                  : holiday.type === "R"
                  ? "restricted-holiday"
                  : null;
              }
            }
          }}
          tileContent={({ date, view }) => {
            const holiday = getHoliday(date);
            if (view === "month" && holiday) {
              return (
                <div className="holiday-tooltip">
                  <span className="holiday-name">{holiday.name}</span>
                </div>
              );
            }
            return null;
          }}
        />
        <div className="holiday-category-wrap">
          <div className="restricted">
            <span></span>
            Gazetted Holiday
          </div>
          <div className="gazetted">
            <span></span>
            Restricted Holiday
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeCalendar;
